// extracted by mini-css-extract-plugin
module.exports = {"md":"related-logo_md_2GlxJ","ios":"related-logo_ios_OegOQ","logo":"related-logo_logo_ob5mX"};